<template>
  <div>
    <router-view></router-view>
    <div style="position:fixed;text-align:center;bottom:0;margin:0 auto;width:100%;color: #5c6b77">
      <p style="font-size:13px;font-weight:bold; display: none;"> Copyright 2021 内蒙古天穹科技有限公司 www.nmgtqkj.com 版权所有 </p>
      <p style="font-size:13px;font-weight:bold">备案号：<a  style="color: #5c6b77" href="https://beian.miit.gov.cn/#/Integrated/index/" target="_blank">
        蒙ICP备2022000297号-2</a> </p>
    </div>
  </div>
</template>

<script>
import projectConfig from '@/core/config';

export default {
  watch: {
    $route: {
      handler (newValue) {
        document.title = projectConfig.projectName;
        if (newValue.meta && newValue.meta.title) document.title += ' - ' + newValue.meta.title;
      },
      immediate: true
    }
  }
}
</script>
